import React, { Component } from "react";
import withFilterOptions from "../hocs/withFilterOptions";
import withItems from "../hocs/withItems";
import { Spin, Radio, Row, Col } from "antd";
import FormItem from "./FormItem";

import "./Collection/index.css";

class RadioComponent extends Component {
  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <FormItem {...this.props}>
        {getFieldDecorator(this.props.attribute, this.props.fieldSettings)(
          <Radio.Group onChange={this.props.handleChange}>
            <Row>
              {this.props.items.length > 1 ? (
                this.props.items.map(i => (
                  <Col span={8} key={i.id}>
                    <Radio value={i.id}>{i.name}</Radio>
                  </Col>
                ))
              ) : (
                <Spin />
              )}
            </Row>
          </Radio.Group>
        )}
      </FormItem>
    );
  }
}

export default withFilterOptions(withItems(RadioComponent));



// WEBPACK FOOTER //
// ./src/inputs/Radio.js